// components/forms/ContactForm.tsx
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { contactFormSchema, type ContactFormSchema } from "@/validation-schemas/contact-us-schemas";
import { InputField } from "@/design-system/Atoms/InputField";
import { TextAreaField } from "@/design-system/Atoms/TextArea";
import { Button } from "@/design-system/Atoms";
import { useContactFormSubmission } from "@/rtkQuery/features/hooks/useContactFormSubmission";
import { useScrollToSection } from "@/hooks/useScrollToSection";

export const ContactUsFormSection = () => {

    const { ref } = useScrollToSection<HTMLElement>({
        behavior: 'smooth',
        block: 'start',
        offset: 80
    });

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
    } = useForm<ContactFormSchema>({
        resolver: zodResolver(contactFormSchema),
    });

    const { submitContactForm, isLoading } = useContactFormSubmission();

    const onSubmit = async (data: ContactFormSchema) => {
        try {
            await submitContactForm(data);
            reset();
        } catch (err: any) {
            console.error("contact us erro ", err)
        }
    };

    return (
        <section ref={ref} id="contact-us-feature" className="contact-form bg-white bg-[url('/images/bg-contact.svg')] bg-no-repeat bg-top bg-cover py-20 lg:py-40">
            <div className="container mx-auto px-4">
                <div className="max-w-[54rem] mx-auto bg-[#f6f7f9] p-6 rounded-2xl">
                    <form onSubmit={handleSubmit(onSubmit)} noValidate>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                            <InputField
                                placeholder="First name"
                                register={register("firstName")}
                                error={errors.firstName?.message}
                            />
                            <InputField
                                placeholder="Last name"
                                register={register("lastName")}
                                error={errors.lastName?.message}
                            />
                            <InputField
                                placeholder="Email"
                                type="email"
                                register={register("email")}
                                error={errors.email?.message}
                                className="md:col-span-2"
                            />
                        </div>
                        <div className="mb-6">
                            <TextAreaField
                                placeholder="Type your message..."
                                register={register("message")}
                                error={errors.message?.message}
                                rows={6}
                            />
                        </div>
                        <Button
                            variant="secondary"
                            size="xl"
                            className="!w-full"
                            type="submit"
                            disabled={isSubmitting || isLoading}
                            loading={isSubmitting || isLoading}
                        >
                            {isLoading ? "Submitting..." : "Submit"}
                        </Button>
                    </form>
                </div>
            </div>
        </section>
    );
};
